import { useState } from "react";
import { Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
import axios from "../../utils/axios";
import { Translate } from "../../translate";
import { getStore } from "../../utils/global";
import custom from "../../utils/custom";
import PreviewRoot from "../PreviewRoot";
import { useQuery } from "react-query";

const DragDrop = ({ parts = [], stamps = [], setStamps = () => {}, file = null, hideTag = true }) => {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const fields = getStore("fields");
  const customFields = getStore("customFields");
  const [selected, setSelected] = useState(0);
  const [lastSelected, setLastSelected] = useState(null);
  const [selectedUser, setSelectedUser] = useState(parts[0]);
  const [activeI, setActiveI] = useState(null);
  const [page, setPage] = useState(1);

  const onDragStart = (event, per) => {
    setLastSelected(per);
    let user = selectedUser;
    let newCrt = document.createElement("div");
    newCrt.setAttribute("class", "drag");
    newCrt.innerHTML = `<span class="${per.url ? "yourSignature" : ""}">${per.drag_txt}</span> ${
      per.unique_key === "signature" ? `<span class="stamp_username">${user.name}</span>` : ""
    }`;
    newCrt.style.backgroundColor = user.color;
    newCrt.style.height = per.style?.height + "px";
    newCrt.style.width = per.style?.width + "px";
    newCrt.style.position = "absolute";
    newCrt.style.bottom = `-${per.style?.height}px`;
    newCrt.style.left = "0";
    newCrt.style.color = "#000000";
    newCrt.style.textAlign = "center";
    newCrt.style.zIndex = "-1";
    if (per.url) {
      newCrt.style.backgroundColor = "#ffffff";
      newCrt.style.backgroundImage = "url('" + per.url + "')";
      newCrt.style.backgroundRepeat = "no-repeat";
      newCrt.style.backgroundSize = "contain";
      newCrt.style.backgroundPositionX = "right";
    }

    event.target.appendChild(newCrt);
    event.dataTransfer.setDragImage(newCrt, 0, per.style?.height / 2);

    window.setTimeout(function () {
      newCrt.parentNode.removeChild(newCrt);
    }, 0);
  };

  const onDragEnd = (event) => {
    let container = document.querySelector(".document_watermark_container_dropable");
    container = container.getBoundingClientRect();
    let boxz = document.querySelector(".document_watermark_container");
    let currentwidth = boxz.clientWidth;
    let currentHeight = boxz.clientHeight;

    let x = event.clientX,
      y = event.clientY,
      px = container.left,
      px1 = container.left + container.width,
      py = container.top,
      py1 = container.top + container.height;

    if (x >= px && x <= px1 && y >= py && y <= py1) {
      let item = { ...lastSelected };

      item.type = item.unique_key;
      item.left = event.pageX - container.left;
      item.bottom = container.height + container.top - event.pageY - item.style.height / 2;
      item.color = selectedUser?.color;
      item.backgroundColor = selectedUser?.color;
      item.uid = selectedUser?.user_id;
      item.msisdn = selectedUser?.msisdn;
      item.x1 = item.left;
      item.page = page;
      item.y1 = item.bottom;
      item.width = item.style.width;
      item.height = item.style.height;
      item.part_index = selected;
      item.pageWidth = currentwidth;
      item.pageHeight = currentHeight;

      if (["yourStamp", "yourSignature", "yourInitials"].includes(item.unique_key)) item.value = item.imageid;
      else item.value = "";

      let overlapped = [];

      let tmpStamps = stamps;
      tmpStamps.forEach((el) => {
        let active = {
          x1: item.x1,
          y1: item.y1,
          x2: item.x1 + item.width,
          y2: item.y1 + item.height,
        };
        let elem = {
          x1: el.x1,
          y1: el.y1,
          x2: el.x1 + el.width,
          y2: el.y1 + el.height,
        };
        el.page === page && overlapped.push(custom.intersect(active, elem));
      });
      if (!overlapped.includes(true)) {
        let tmp = [...tmpStamps, item];
        setStamps(tmp);
        setActiveI(tmp.length - 1);
        if (lastSelected.unique_key === "signature") {
          item.username = selectedUser?.name;
          parts[selected].move_sign = true;
        }
      }
    }
  };

  const renderIcon = (type) => {
    switch (type) {
      case "signer":
        return <EditOutlined />;
      case "approver":
        return <UserOutlined />;
      default:
        return <MailOutlined />;
    }
  };

  const deleteStamp = (id) => {
    let tmp = [...stamps];
    tmp.splice(id, 1);
    setStamps(tmp);
    setActiveI(null);

    let idx = selected;
    let item = stamps[id];

    if (item.unique_key === "signature") {
      parts[idx].move_sign = false;
    }
  };

  const { data: userStamps = [] } = useQuery({
    queryKey: ["get_user_details", selectedUser?.user_id],
    queryFn: () => axios.get(`/client/api/user/${selectedUser?.user_id}`),
    select: ({ data }) => {
      const types = {
        eseal: "yourStamp",
        signature: "yourSignature",
        initials: "yourInitials",
      };

      const sizes = {
        eseal: { height: 150, width: 150 },
        signature: { height: 75, width: 150 },
        initials: { height: 75, width: 75 },
      };
      const { images } = data?.data;

      const arr = images?.map((e) => ({
        ...e,
        svgurl: true,
        icon: "stamp",
        drag_txt: e.shortname,
        drag_desc: e.description,
        unique_key: types[e.imagetype],
        style: sizes[e.imagetype],
      }));
      return arr;
    },
  });

  return (
    <div className="draggable_container">
      <div
        style={{
          height: "calc(100% - 43px)",
          overflowY: "auto",
          backgroundColor: "white",
        }}>
        <div className="draggable_fields_container">
          <div className="drag_field_title">{Translate[ln].NewDoc.Customizations.Participants}</div>
          <div style={{ padding: "0 20px", paddingTop: 10 }}>
            <Select
              value={selected}
              onChange={(data) => {
                setSelected(data);
                setSelectedUser(parts[data]);
              }}
              style={{ width: "100%" }}>
              {parts.map((per, i) => (
                <Select.Option key={i} value={i} style={{ background: per.color }}>
                  {renderIcon(per.actionrole)}
                  &nbsp;{per.name || per.msisdn || per.email}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="drag_field_title">{Translate[ln].NewDoc.Customizations.StandartFields}</div>
          <div className="seperator_field" style={{ display: "block" }} />
          {fields?.map((per, i) => {
            let style = {};
            if ((!selectedUser?.can_sign || selectedUser?.move_sign) && per.unique_key === "signature") {
              return false;
            }
            return (
              <div
                draggable
                style={style}
                key={per.key}
                custom_type={per.unique_key}
                className="drag_field_container"
                onDragStart={(event) => {
                  onDragStart(event, per);
                }}
                onDragEnd={onDragEnd}>
                <div className="drag_field_icon">
                  <div className="drag_field_icon_box" style={{ background: selectedUser?.color }}>
                    <FontAwesomeIcon icon={per.icon} />
                  </div>
                </div>
                <div className="drag_field_name">{Translate[ln].NewDoc.Customizations.Stands[i]}</div>
              </div>
            );
          })}
          <div className="drag_field_title" onClick={() => console.log(customFields)}>
            {Translate[ln].NewDoc.Customizations.CustomFields}
          </div>
          <div className="seperator_field" style={{ display: "block" }} />
          {customFields?.map((per, i) => {
            return (
              !per.svgurl && (
                <div
                  draggable
                  key={per.key}
                  custom_type={per.unique_key}
                  className="drag_field_container"
                  onDragStart={(event) => {
                    onDragStart(event, per);
                  }}
                  onDragEnd={onDragEnd}>
                  <div className="drag_field_icon">
                    <div className="drag_field_icon_box" style={{ background: selectedUser?.color }}>
                      <FontAwesomeIcon icon={per.icon} />
                    </div>
                  </div>
                  <div className="drag_field_name">
                    {Translate[ln].NewDoc.Customizations.Customs[i]}
                    <div className="characters"> ~ {per.maxChar || 0} char</div>
                  </div>
                </div>
              )
            );
          })}
          {!hideTag && (
            <div className="drag_field_title">
              {Translate[ln].NewDoc.Customizations.Userimgs}
              <div className="seperator_field" style={{ display: "block" }} />
            </div>
          )}
          <div>
            <div>
              {userStamps?.map((per, idx) => {
                return (
                  <div
                    style={{
                      border: "1px solid #eee",
                      margin: "8px 20px",
                      display: "flex",
                      padding: "15px 10px",
                      alignItems: "center",
                    }}
                    draggable
                    key={per.imageid}
                    className="drag_sign_stamp"
                    onDragStart={(event) => {
                      onDragStart(event, per);
                    }}
                    onDragEnd={onDragEnd}>
                    <img src={`/${per.imagetype}.png`} alt={`${per.imagetype}`} style={{ height: "25px" }} />
                    <div style={{ padding: "0 10px" }}>
                      <div style={{ fontWeight: "600" }}>{per.shortname}</div>
                      <div style={{ fontSize: "11px" }}>{per.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {activeI !== null && (
            <div
              className="last_selected"
              style={{
                background: stamps[activeI]?.color,
              }}>
              <div className="last_selected_title">Last selected :</div>
              <div className="last_selected_container">
                <FontAwesomeIcon icon={["fas", stamps[activeI]?.icon]} /> <span>{stamps[activeI]?.drag_txt}</span>
                <div className="last_selected_delete" onClick={() => deleteStamp(activeI)}>
                  <FontAwesomeIcon icon={["fas", "trash"]} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="draggable_pdf_container">
        <div className="absfull">
          <PreviewRoot
            file={file}
            pageChange={setPage}
            onSuccess={() => {
              let element = document.createElement("div");
              let dropable = document.createElement("div");
              dropable.className = "document_watermark_container_dropable";
              element.className = "document_watermark_container";
              element.appendChild(dropable);
              document.querySelector(".react-pdf__Page").appendChild(element);
              element.addEventListener("dragend", (e) => {
                e.preventDefault();
                document.querySelector(".document_watermark_container_dropable").style.zIndex = 0;
              });
              element.addEventListener("dragover", (e) => e.preventDefault());
            }}
            stamps={stamps}
            selectedUser={selectedUser}
            setStamps={setStamps}
            setActive={(id) => setActiveI(id)}
            allUsers={parts}
          />
        </div>
      </div>
    </div>
  );
};

export default DragDrop;
